export const supportEmail = 'mailto:support@bridge128.com';

export const biddingSystems = [
	{
		text: 'ACOL (UK, NZ, Ireland)',
		value: 'ACOL'
	},
	{
		text: 'SAYC (USA, most of the rest of the world)',
		value: 'SAYC'
	},
	{
		text: 'Majeurs Cinquieme (France)',
		value: 'Majeurs Cinquieme'
	},
	{
		text: '2-over-1 (Advanced players)',
		value: '2-over-1'
	}
];

export const suitOrder = [
	'spades',
	'hearts',
	'diamonds',
	'clubs'
];

export const vulnerabilities = [
	'Unimportant',
	'Non-Vol vs Non-Vul',
	'Non-Vul vs Vul',
	'Vul vs Non-vul',
	'Vul vs Vul'
];

export const activityTypes = [
	{
		text: 'Video',
		value: 'video'
	},
	{
		text: 'Presentation',
		value: 'embeddedPresentation'
	},
	// decided late in the project that
	// quiz should be called a question in FE
	// it is too late to change all FE code to refer
	// to the term question instead of quiz
	// so keep calling it a quiz internally
	// a later v2 of quiz might have multiple questions
	// and use the term quiz in FE
	{
		text: 'Question',
		value: 'quiz'
	},
	{
		text: 'Deal run-through',
		value: 'deal'
	},
	{
		text: 'Intertitle',
		value: 'titlePage'
	}
];

export const cardOrder = [
	'A',
	'K',
	'Q',
	'J',
	'T',
	'9',
	'8',
	'7',
	'6',
	'5',
	'4',
	'3',
	'2'
];

export const playerAbility = [
	'Club',
	'Tournament',
	'National Team',
	'Champion'
];

export const POSITIONS_SHORT = {
	WEST: 'W',
	NORTH: 'N',
	EAST: 'E',
	SOUTH: 'S'
};

export const DEFAULT_PLAYER_POSITION = POSITIONS_SHORT.SOUTH;

export const TABLE_POSITIONS = {
	TOP: 'top',
	RIGHT: 'right',
	BOTTOM: 'bottom',
	LEFT: 'left'
};

export const defaultTablePositions = [
	{
		tablePosition: TABLE_POSITIONS.TOP,
		playerPosition: POSITIONS_SHORT.NORTH
	},
	{
		tablePosition: TABLE_POSITIONS.RIGHT,
		playerPosition: POSITIONS_SHORT.EAST
	},
	{
		tablePosition: TABLE_POSITIONS.BOTTOM,
		playerPosition: POSITIONS_SHORT.SOUTH
	},
	{
		tablePosition: TABLE_POSITIONS.LEFT,
		playerPosition: POSITIONS_SHORT.WEST
	}
];

export const DEFAULT_PLAYER_TABLE_POSITION = TABLE_POSITIONS.BOTTOM;

export const seatPositions = [
	{
		text: 'West',
		value: POSITIONS_SHORT.WEST
	},
	{
		text: 'North',
		value: POSITIONS_SHORT.NORTH
	},
	{
		text: 'East',
		value: POSITIONS_SHORT.EAST
	},
	{
		text: 'South',
		value: POSITIONS_SHORT.SOUTH
	}
];

export const SEATS = {
	N: { name: 'North', short: 'N', partner: 'S', pair: 'NS', left: 'E' },
	S: { name: 'South', short: 'S', partner: 'N', pair: 'NS', left: 'W' },
	E: { name: 'East', short: 'E', partner: 'W', pair: 'EW', left: 'S' },
	W: { name: 'West', short: 'W', partner: 'E', pair: 'EW', left: 'N' }
};

export const partnerships = [
	['N', 'S'],
	['E', 'W']
];

export const experienceLevels = [
	{
		text: '1 (Absolute Beginner)',
		value: 1
	},
	{
		text: '2 (Beginner+)',
		value: 2
	},
	{
		text: '3 (Improver)',
		value: 3
	},
	{
		text: '4 (Improver+)',
		value: 4
	},
	{
		text: '5 (Intermediate)',
		value: 5
	},
	{
		text: '6 (Intermediate+)',
		value: 6
	},
	{
		text: '7 (Advanced)',
		value: 7
	},
	{
		text: '8 (Advanced+)',
		value: 8
	},
	{
		text: '9 (Tournament)',
		value: 9
	},
	{
		text: '10 (World Class)',
		value: 10
	}
];

export const defaultResourceCategory = 'general_lesson_resource';

export const resourceCategoryOptions = [
	{
		text: 'Course sheets',
		value: 'general_lesson_resource',
		icon: 'v2-paperclip'
	},
	{
		text: 'Hand record',
		value: 'hand_record',
		icon: 'v2-list-ul'
	},
	// TODO: Keep this file category just in case
	//  We already have a separate page for simulator deals management
	//  /teaching/courses/{course_id}/lessons/{lesson_id}/deals
	{
		text: 'Simulator deal',
		value: 'simulator_deal',
		icon: 'v2-rocket'
	}
];

export const dealRecordingType = 'deal_recording';

export const dealAnalysisType = 'deal_analysis';

export const SIMULATOR_MODES = {
	PREVIEW: 'preview',
	STUDY: 'study',
	PLAY: 'play'
};

export const DONT_SHOW_CHANGE_PLAYER_POSITION_NOTIFICATION_KEY = 'DONT_SHOW_CHANGE_PLAYER_POSITION_NOTIFICATION_KEY';

export const suitOptions = [
	{
		value: 'H',
		symbol: '♥',
		colour: 'red'
	},
	{
		value: 'D',
		symbol: '♦',
		colour: 'red'
	},
	{
		value: 'S',
		symbol: '♠',
		colour: 'black'
	},
	{
		value: 'C',
		symbol: '♣',
		colour: 'black'
	}
];

export const differenceOptions = [
	{
		value: '-',
		condition: '-'
	},
	{
		value: 'makes',
		condition: 'makes'
	},
	{
		value: 'max',
		condition: 'max'
	}
];

export const defaultResultMessages = {
	'-': 'Bad luck!',
	makes: 'Well played!',
	max: 'Brilliant!'
};

export const GAME_MODES = {
	STANDALONE: 'standalone',
	STUDENT: 'student',
	TEACHER: 'teacher'
};

export const LEGACY_GAME_MODES_MAP = {
	[SIMULATOR_MODES.PLAY]: GAME_MODES.STANDALONE,
	[SIMULATOR_MODES.STUDY]: GAME_MODES.STUDENT,
	[SIMULATOR_MODES.PREVIEW]: GAME_MODES.TEACHER
};

export const DEAL_LINK_ACCESSIBILITY_OPTIONS = {
	EVERYONE: 'everyone',
	ALL_SUBSCRIBERS: 'all_subscribers',
	PAYING_SUBSCRIBERS: 'paying_subscribers'
};

export const uppercaseAlphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

export const DEFAULT_LOCALE = 'en-GB';
